import { render, staticRenderFns } from "./DoctorPatientDetail.vue?vue&type=template&id=26ce1702&"
import script from "./DoctorPatientDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorPatientDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports